import { gsap } from 'gsap'
import $ from 'jquery'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

var img1 = document.querySelector('.img-1')
var img2 = document.querySelector('.img-2')
var img3 = document.querySelector('.img-3')
var img4 = document.querySelector('.img-4')
var img5 = document.querySelector('.img-5')
var img6 = document.querySelector('.img-6')
var img7 = document.querySelector('.img-7')
var img8 = document.querySelector('.img-8')
var dot1 = document.querySelector('.dot-1')
var dot2 = document.querySelector('.dot-2')
var dot3 = document.querySelector('.dot-3')
var dot4 = document.querySelector('.dot-4')
var dot5 = document.querySelector('.dot-5')
var dot6 = document.querySelector('.dot-6')
var dot7 = document.querySelector('.dot-7')
var dot8 = document.querySelector('.dot-8')
var box1 = document.querySelector('.box-1')
var box2 = document.querySelector('.box-2')
var box3 = document.querySelector('.box-3')
var box4 = document.querySelector('.box-4')
var box5 = document.querySelector('.box-5')
var box6 = document.querySelector('.box-6')
var box7 = document.querySelector('.box-7')
var box8 = document.querySelector('.box-8')
var cross1 = document.querySelector('.cross-1')
var cross2 = document.querySelector('.cross-2')
var cross3 = document.querySelector('.cross-3')
var cross4 = document.querySelector('.cross-4')
var cross5 = document.querySelector('.cross-5')
var cross6 = document.querySelector('.cross-6')
var cross7 = document.querySelector('.cross-7')
var cross8 = document.querySelector('.cross-8')

function imgAppear(img) {
  img.style.opacity = '1'
  img.style.zIndex = '100'
}

function imgDisepear(img) {
  img.style.opacity = '0'
  img.style.zIndex = '0'
}

function addListeners(img, dot) {
  let isTouch = false
  dot.addEventListener('touchstart', () => {
    isTouch = true
  })

  dot.addEventListener('mouseenter', () => {
    if (!isTouch) {
      imgAppear(img)
    }
  })

  dot.addEventListener('mouseleave', () => {
    imgDisepear(img)
  })
}

function boxOpen(box) {
  box.style.opacity = '1'
  box.style.zIndex = '120'
}

function boxOpener(dot, box) {
  dot.addEventListener('click', () => {
    boxOpen(box)
  })
}

function boxClose(box) {
  box.style.opacity = '0'
  box.style.zIndex = '-1'
}

function crossCloser(cross, box) {
  cross.addEventListener('click', () => {
    console.log('clicked')
    boxClose(box)
  })
}

addListeners(img1, dot1)
addListeners(img2, dot2)
addListeners(img3, dot3)
addListeners(img4, dot4)
addListeners(img5, dot5)
addListeners(img6, dot6)
addListeners(img7, dot7)
addListeners(img8, dot8)
boxOpener(dot1, box1)
boxOpener(dot2, box2)
boxOpener(dot3, box3)
boxOpener(dot4, box4)
boxOpener(dot5, box5)
boxOpener(dot6, box6)
boxOpener(dot7, box7)
boxOpener(dot8, box8)
crossCloser(cross1, box1)
crossCloser(cross2, box2)
crossCloser(cross3, box3)
crossCloser(cross4, box4)
crossCloser(cross5, box5)
crossCloser(cross6, box6)
crossCloser(cross7, box7)
crossCloser(cross8, box8)
